module.exports = __webpack_public_path__ + "static/inbound-leads-5fd213d888302641562659afbb799e4b.png";